import type { MatchState } from "../sim";

export const SEGMENT = 1000;
export const SEGMENTS = 3;
export const FULL_FLASH_FRAMES = 45;
export const SPEND_FRAMES = 26;

export interface SpendEffect {
  readonly side: number;
  readonly segment: number;
  frames: number;
}

/**
 * Что показывает шкала Ярости, без рисования: плавное накопление, вспышка полной шкалы, гаснущие потраченные
 * деления. Шагает кадрами мира — одинаково в игре и в записи ролика.
 */
export class MeterDisplay {
  shown: [number, number] = [0, 0];
  fullFlash: [number, number] = [0, 0];
  spends: SpendEffect[] = [];
  tick = 0;
  private ready: [number, number] = [0, 0];
  private lastFrame = -1;

  advance(state: MatchState): void {
    if (state.frame === this.lastFrame) return;
    const steps = this.lastFrame < 0 ? 1 : Math.max(1, Math.min(8, state.frame - this.lastFrame));
    this.lastFrame = state.frame;
    for (let step = 0; step < steps; step++) {
      this.tick++;
      state.fighters.forEach((fighter, side) => {
        const shown = this.shown[side] ?? 0;
        this.shown[side] =
          fighter.meter < shown
            ? fighter.meter
            : Math.min(fighter.meter, shown + Math.max(12, (fighter.meter - shown) * 0.12));
        const ready = Math.floor(fighter.meter / SEGMENT);
        const before = this.ready[side] ?? 0;
        if (ready > before && ready === SEGMENTS) this.fullFlash[side] = FULL_FLASH_FRAMES;
        for (let segment = ready; segment < before; segment++)
          this.spends.push({ side, segment, frames: SPEND_FRAMES });
        this.ready[side] = ready;
        if ((this.fullFlash[side] ?? 0) > 0) this.fullFlash[side] = (this.fullFlash[side] ?? 0) - 1;
      });
      for (const spend of this.spends) spend.frames--;
      this.spends = this.spends.filter((spend) => spend.frames > 0);
    }
  }

  reset(): void {
    this.shown = [0, 0];
    this.fullFlash = [0, 0];
    this.spends = [];
    this.ready = [0, 0];
    this.lastFrame = -1;
  }
}
